import { ApiAddress } from "../apis"
import request from "../request"

export interface MaterialBlance {
  id: number
  name: string
  description: string
  cases: number[]
  streams: Array<{uuid: number}>
}

export interface MaterialBlanceState {
  id: number
  name: string
  description: string
  cases: number[]
  streams: MaterialBlanceCaseStream[]
}

export interface MaterialBlanceCaseStream {
  flash: string
  id: string
  phases: StreamPhase[]
  ppsId: number
  ppsName: string
  status: string
  tag: string
  uuid: string
}

export interface StreamPhase {
  cp?: number
  cv?: number
  h: number
  hhv: number
  lhv: number
  mw: number
  p: number
  pf: number
  phase: string
  rho: number
  s: number
  state: string
  t: number
  x: number[]
  z?: number
  eta?: number
  k?: number
  f?: number
  pc?: number
  tc?: number
  vf?: number
}


export interface MaterialBlanceStream {
  dsc: string
  tag: string
  uuid: string
}

const simHeader = {'SIM-TOKEN': '1111'}

export function createMaterialBalance(body, params) {
  return request.post(ApiAddress.MATERIAL_BLANCES, body, params)
}

export function getMaterialBalances(pId): Promise<MaterialBlance[]> {
  return request.get(ApiAddress.MATERIAL_BLANCE_LIST, {params: {pId}})
}

export function deleteMaterialBalances(id): Promise<MaterialBlance> {
  return request.delete(ApiAddress.MATERIAL_BLANCE, {params: {id}})
}

export function getMaterialBalance(id): Promise<MaterialBlance> {
  return request.get(ApiAddress.GET_MATERIAL_BLANCE, {params: {id}})
}

const mockBody = {"props":[{"phase":"bulk","prop":"rho"},{"phase":"bulk","prop":"m_rho"},{"phase":"bulk","prop":"vis"},{"phase":"bulk","prop":"cond"},{"phase":"bulk","prop":"m"},{"phase":"bulk","prop":"cp"},{"phase":"bulk","prop":"m_cp"},{"phase":"bulk","prop":"cv"},{"phase":"bulk","prop":"m_cv"},{"phase":"bulk","prop":"cpcv"},{"phase":"bulk","prop":"snd"},{"phase":"bulk","prop":"tens"},{"phase":"bulk","prop":"lhv"},{"phase":"bulk","prop":"hhv"}]}
export function generateStreams(sId: number) {
  return request.put(ApiAddress.GENERATE_STREAMS, mockBody, {params: {sId}, headers: simHeader})
}

export function getProjectStreams(pId): Promise<MaterialBlanceStream[]> {
  return request.get(ApiAddress.MATERIAL_STREAM_LIST, {params: {pId}})
}

export function updateMaterialBalance(body, id) {
  return request.put(ApiAddress.MATERIAL_BLANCE, body, {params: {id}})
}

export function getMaterialBalanceForCase(params): Promise<MaterialBlanceState> {
  return request.get(ApiAddress.MATERIAL_BLANCE_CASE, {params})
}
